// extracted by mini-css-extract-plugin
module.exports = {"settingsType":"SettingsIndex_settingsType__3F5fs"};